import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ServiceProviderIndustryAppResource from "./ServiceProviderIndustryAppResource";
import ServiceProviderAppResource from "./ServiceProviderAppResource";
import ServiceProviderProjectTypeAppResource from "./ServiceProviderProjectTypeAppResource";
import FileAppResource from './FileAppResource';
import OrganizationAppResource from "./OrganizationAppResource";


export const SERVICE_PROVIDER_TYPE_HO_INSURANCE = 'Homeowners Insurance';
export const SERVICE_PROVIDER_TYPE_HO_WARRANTY = 'Home Warranty';
export const SERVICE_PROVIDER_TYPE_ARCHITECTS_BUILDING_DESIGNERS = 'Architects & Building Designers';
export const SERVICE_PROVIDER_TYPE_KITCHEN_BATHROOM_DESIGNERS = 'Kitchen & Bathroom Designers';
export const SERVICE_PROVIDER_TYPE_GENERAL_CONSTRUCTORS = 'General Contractors';
export const SERVICE_PROVIDER_TYPE_REMODELING_CONTRACTORS = 'Remodeling Contractors';
export const SERVICE_PROVIDER_TYPE_KITCHEN_BATHROOM_REMODELERS = 'Kitchen & Bathroom Remodelers';
export const SERVICE_PROVIDER_TYPE_INTERIOR_DESIGNERS_DECORATORS = 'Interior Designers & Decorators';
export const SERVICE_PROVIDER_TYPE_DESIGN_BUILD_FIRMS = 'Design-Build Firms';

class ServiceProviderTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'serviceProviderIndustryUuid',
            'industry',
            'serviceProviders',
            'projectTypes',
            'imageUuid',
            'excludedInOrganizations',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            industry: ServiceProviderIndustryAppResource,
            serviceProviders: ServiceProviderAppResource,
            projectTypes: ServiceProviderProjectTypeAppResource,
            image: FileAppResource,
            excludedInOrganizations: OrganizationAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            industry: 'service_provider_industry_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            serviceProviderIndustryUuid: {
                type: 'string',
                presence: true,
            },
            imageUuid: {
                type: 'string',
            },
        };
    }
}

export default ServiceProviderTypeAppResource;
